import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class SomatorioHorasExtrasMOTAStore {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable empresasGlobo;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findSomatorioHorasExtrasMOTA(filtro).then(response => {
            const cargosAgrupados = _.groupBy(response.data, (d) => d.cargo);
            const cargos = Object.keys(cargosAgrupados);
            const empresasGloboAgrupadas = _.groupBy(response.data, (d) => d.empresa);
            const empresasGlobo = Object.keys(empresasGloboAgrupadas);

            let dados = [];
            _.forEach(cargos, (cargo) => {
                let dado = { nome: cargo };

                const cargosEmpresasGlobo = cargosAgrupados[cargo];

                _.forEach(cargosEmpresasGlobo, (cargoEmpresaGlobo) => {
                    dado = { ...dado, [cargoEmpresaGlobo.empresa]: cargoEmpresaGlobo.quantidade };
                });

                dados = [ ...dados, dado ];
            });

            this.empresasGlobo = empresasGlobo;
            this.dados = dados;
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }
}
